module.exports = __webpack_public_path__ + "static/blue-band-552f1b92f5f220ef90ff6590a4ba5447.png";